import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>About Optimus</h1>
            <p>
              Learn more about our mission to streamline business operations
              with modern POS solutions.
            </p>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h3>Our Mission</h3>
              <p>
                To provide businesses with powerful, easy-to-use POS and API
                solutions that streamline operations and drive growth.
              </p>
            </div>
            <div className="content-card">
              <h3>Our Vision</h3>
              <p>
                To be the leading provider of innovative business solutions that
                empower companies to achieve their full potential.
              </p>
            </div>
            <div className="content-card">
              <h3>Our Values</h3>
              <p>
                Innovation, reliability, and customer success are at the core of
                everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default About;
